import {
  getPromoBannerAPI,
  postPromoBannerAPI,
  putPromoBannerAPI,
  deletePromoAPI,
} from "../api";

export default {
  namespaced: true,

  state: {
    data: {
      promoEvents: [],
      isLoading: false,
    },
  },

  getters: {
    getPromoEvents: (state) => state.data.promoEvents,
    getPromoLoading: (state) => state.data.isLoading,
  },

  actions: {
    actionGetPromoEvents({ commit, rootState }) {
      const { env } = rootState.selectEnv.data;
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        getPromoBannerAPI(env).then(
          (response) => {
            commit("SET_PROMO", response);
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            resolve(response);
          },
          (error) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            reject(error);
          }
        );
      });
    },

    actionSetPromoEvents({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      if (payload && !payload.eventKey) {
        return new Promise((resolve, reject) => {
          postPromoBannerAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      } else {
        return new Promise((resolve, reject) => {
          putPromoBannerAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      }
    },

    actionDeletePromoEvent({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        deletePromoAPI(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            console.log("err: ", err);
            reject(err);
          });
      });
    },
  },

  mutations: {
    SET_PROMO(state, payload) {
      state.data.promoEvents = payload;
    },
    SET_IS_LOADING(state, payload) {
      state.data.isLoading = payload;
    },
  },
};
